import {
    game
} from "../Game";
import { applyFixedBodySetting } from './fixedBody';
import { gameRandom } from '../utils/GameRandom';

export class basePrefab {
    static settings = {};
    static settingsOptions = {};
    static forceUnique = false;
    constructor(target) {
        this.prefabObject = target;
        this.lookupObject = game.editor.lookupGroups[this.prefabObject.prefabName + "_" + this.prefabObject.instanceID];
        this.contactListener;
    }
    postConstructor(){
    }
    init() {
        this.lookupObject = game.editor.lookupGroups[this.prefabObject.prefabName + "_" + this.prefabObject.instanceID];
        this.initContactListener();
    }
    set(property, value) {
        this.prefabObject.settings[property] = value;
    }
    update() {}
    initContactListener() {
        this.contactListener = new Box2D.JSContactListener();
        this.contactListener.BeginContact = function (contact, target) {}
        this.contactListener.EndContact = function (contact, target) {}
        this.contactListener.PreSolve = function (contact, oldManifold) {}
        this.contactListener.PostSolve = function (contact, impulse) {}
    }
    destroy(){
        if(this.destroyed) return;
        game.editor.deleteObjects([this.prefabObject]);
        this.destroyed = true;
    }
    reset(){
    }
}

export class weaponPrefab extends basePrefab {
    static settings = Object.assign({}, basePrefab.settings, {
        "isFixed": false,
    });
    static settingsOptions = Object.assign({}, basePrefab.settingsOptions, {
        "isFixed": false,
    });

    init() {
        super.init();
        applyFixedBodySetting(this.lookupObject._bodies[0], this.prefabObject.settings?.isFixed);
    }
}

export const copyFixProperties = {
    'SevenSegment':['linkedSegmentId', 'linkedTriggerData'],
    'Animator':['linkedTargetId', 'linkedReferenceId'],
    'Portal':['linkedPortalId'],
};


export const LIBRARY_ADMIN = "admin";
export const LIBRARY_MOVEMENT = "movement";
export const LIBRARY_DECORATION = "decoration";
export const LIBRARY_WEAPON = "weapon";
export const LIBRARY_LEVEL = "level";
export const LIBRARY_CHARACTERS = "characters";
export const LIBRARY_BLUEPRINTS = "blueprints";
export const LIBRARY_MISC = "misc";

export var prefabLibrary = {
    libraryKeys: [],
    libraryDictionary: {},
}
// The order a library shows its prefabs in; prefabs not listed follow in load order.
const LIBRARY_ORDER = {
    [LIBRARY_WEAPON]: ['Laser', 'Turret', 'SawDrone', 'DroneBomb', 'Katana', 'Grenade', 'Landmine', 'ExplosiveBarrel', 'Cannon', 'CrossBow', 'Beartrap', 'Axe', 'Spear', 'Spikes', 'CannonBall', 'Arrow'],
};
export const getLibraryKeys = function() {
    if(prefabLibrary.libraryKeys.length>0) return prefabLibrary.libraryKeys;
    for (let key in prefabLibrary) {
        if (prefabLibrary.hasOwnProperty(key)) {
            const libraryKey = prefabLibrary[key].library
            if (libraryKey) {
                if (!prefabLibrary.libraryDictionary[libraryKey]) prefabLibrary.libraryDictionary[libraryKey] = [];
                prefabLibrary.libraryDictionary[libraryKey].push(key);
            }
        }
    }
    for (const [libraryKey, order] of Object.entries(LIBRARY_ORDER)) {
        const rank = key => order.includes(key) ? order.indexOf(key) : order.length;
        prefabLibrary.libraryDictionary[libraryKey]?.sort((a, b) => rank(a) - rank(b));
    }
    prefabLibrary.libraryKeys = Object.keys(prefabLibrary.libraryDictionary).filter(key => ![LIBRARY_ADMIN, LIBRARY_BLUEPRINTS].includes(key));

    return prefabLibrary.libraryKeys;
}


export const timerReady = function (timer, target, singleCallback) {
    return singleCallback ? (timer <= target && timer + game.editor.deltaTime >= target) : timer > target;
}
export const chancePercent = function(percent){
    return gameRandom()*100<percent;
}

// The prefab modules themselves are imported in ./loadPrefabs.js — they extend
// PrefabManager.basePrefab at module-evaluation time, so importing them from
// this file would hoist them above the basePrefab class declaration.
